import { Component, ErrorInfo, ReactNode } from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import { tokenStyles } from "../theme";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// Catches render-time errors anywhere in the tree so a single thrown component doesn't
// white-screen the whole app (React has no hook-based equivalent, hence the class).
class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        // Renders outside the app's providers, so it emits the design tokens itself and is
        // styled by .ih-crash in index.css.
        <main className="ih-crash">
          <GlobalStyles styles={tokenStyles} />
          <h1>Something went wrong.</h1>
          <button type="button" onClick={() => window.location.assign("/home")}>
            Go back home
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
